import api from './api';

// A tenant's reusable "verified profile" built from applications that have reached a recorded
// decision — see TenantPassportController. Behind TENANT_PASSPORT_ENABLED in principle; note that
// as of this writing the backend doesn't actually check that flag on these routes.
export default {
  createPassport: async () => (await api.post('/tenant-passport')).data,
  getMyPassports: async () => (await api.get('/tenant-passport')).data,
  getPassport: async (id) => (await api.get(`/tenant-passport/${id}`)).data,
  sharePassport: async (id, organisationId) => (await api.post(`/tenant-passport/${id}/share`, { organisation_id: organisationId })).data,
  revokePassport: async (id, reason) => (await api.post(`/tenant-passport/${id}/revoke`, { reason })).data,
  revokePassportShare: async (id, organisationId) => (await api.post(`/tenant-passport/${id}/revoke-share`, { organisation_id: organisationId })).data
};
